var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 5.62971V8.00008M7.9 10.3705H7.90585M5.44221 13.3334H10.3578C11.341 13.3334 11.8326 13.3334 12.2081 13.1396C12.5385 12.9692 12.807 12.6972 12.9754 12.3627C13.1667 11.9824 13.1667 11.4846 13.1667 10.489V5.51119C13.1667 4.51554 13.1667 4.01772 12.9754 3.63743C12.807 3.30292 12.5385 3.03096 12.2081 2.86051C11.8326 2.66675 11.341 2.66675 10.3578 2.66675H5.44221C4.459 2.66675 3.96739 2.66675 3.59186 2.86051C3.26153 3.03096 2.99296 3.30292 2.82465 3.63743C2.6333 4.01772 2.6333 4.51554 2.6333 5.51119V10.489C2.6333 11.4846 2.6333 11.9824 2.82465 12.3627C2.99296 12.6972 3.26153 12.9692 3.59186 13.1396C3.96739 13.3334 4.459 13.3334 5.44221 13.3334Z",
    stroke: "#FFAE00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRegular);
export default __webpack_public_path__ + "static/media/alert-regular.e461e524dc6584b498fb4e9b933ece40.svg";
export { ForwardRef as ReactComponent };